import { useDataChainId } from '@ui/hooks/datachain';
import { getContractAddress } from '@ui/services/contract/constants/address';
import { useAccount, useReadContract } from 'wagmi';
import LVMONRedeemer from '@ui/services/contract/abis/LVMONRedeemer';
import { Address } from 'viem';
import { Interval } from '@ui/constants/poll';

export const useUserRedeemRequests = () => {
  const chainId = useDataChainId();
  const { address } = useAccount();
  const contractAddress = getContractAddress('LVMONRedeemer', chainId);

  return useReadContract({
    abi: LVMONRedeemer,
    address: contractAddress,
    functionName: 'getUserRequests',
    args: [address as Address],
    chainId,
    query: {
      enabled: !!address && !!contractAddress,
      refetchInterval: Interval.SLOW,
    },
  });
};
